import {Link} from 'react-router';

import {dataTableActionT, dataTableColumnT} from '@/lib/types/dataTable.types';
import {marketT} from '@/lib/types/market.types';

export const renderMarketTableStats = (
  totalMarkets: number | null | undefined,
  activeMarkets: number | null | undefined,
  inactiveMarkets: number | null | undefined
) => [
  {
    title: 'Total Markets',
    value: totalMarkets,
    subtitle: 'This Month',
    change: 1.03,
    icon: 'ri-price-tag-3-line',
    color: 'primary',
    cardClass: 'bg-primary/10 text-primary',
  },
  {
    title: 'Active Markets',
    value: activeMarkets,
    subtitle: 'This Month',
    change: 0.36,
    icon: 'ri-check-line',
    color: 'secondary',
    cardClass: 'bg-secondary/10 text-secondary',
  },
  {
    title: 'Inactive Markets',
    value: inactiveMarkets,
    subtitle: 'This Month',
    change: -1.28,
    icon: 'ri-close-line',
    color: 'warning',
    cardClass: 'bg-warning/10 text-warning',
  },
];

export const marketColumns: dataTableColumnT<'Market'>[] = [
  {
    header: 'Name',
    field: 'market_name',
    render: (market: marketT) => (
      <Link to={`/markets/${market.market_id}`} className="text-primary hover:text-primary dark:text-primary">
        {market.market_name}
      </Link>
    ),
  },
  {
    header: 'Status',
    field: 'date_removed',
    render: (market: marketT) => (
      <span className={`badge bg-${!market.date_removed ? 'success' : 'danger'} text-white`}>
        {!market.date_removed ? 'Active' : 'Inactive'}
      </span>
    ),
  },
];

export const marketActions = (
  isAdmin: boolean,
  handleEditMarketClick: (row: marketT) => void,
  handleDeleteMarketClick: (row: marketT) => void
): dataTableActionT<'Market'>[] => [
  {
    icon: 'ri-pencil-line',
    color: 'info',
    handler: handleEditMarketClick,
    permission: () => isAdmin,
  },
  {
    icon: 'ri-delete-bin-line',
    color: 'danger',
    handler: handleDeleteMarketClick,
    permission: () => isAdmin,
  },
];
